'use client';

import { Bell, BellOff, ShieldCheck } from 'lucide-react';
import { Modal } from '@/shared/ui/Modal';

interface PushOptInModalProps {
  open: boolean;
  onAllow: () => void;
  onDeny: () => void;
  blocked?: boolean;
}

export function PushOptInModal({
  open,
  onAllow,
  onDeny,
  blocked = false,
}: PushOptInModalProps) {
  return (
    <Modal
      open={open}
      onClose={onDeny}
      title="Browser Notifications"
      size="sm"
    >
      <div id="calls_push_optin_modal" className="p-5 space-y-4">
        {blocked ? (
          <>
            <div className="flex items-center justify-center w-14 h-14 mx-auto rounded-full bg-hms-red/10">
              <BellOff className="w-7 h-7 text-hms-red" />
            </div>
            <p className="text-sm text-hms-textSub text-center">
              Notifications are blocked in your browser settings. To receive
              incoming call alerts, enable notifications in your browser&apos;s
              site settings for this page.
            </p>
            <button
              id="calls_push_optin_close_btn"
              type="button"
              onClick={onDeny}
              className="w-full px-4 py-2.5 rounded-lg text-sm font-medium border border-hms-border text-hms-textSub hover:bg-hms-surface transition-colors"
            >
              Close
            </button>
          </>
        ) : (
          <>
            <div className="flex items-center justify-center w-14 h-14 mx-auto rounded-full bg-hms-gold/10">
              <Bell className="w-7 h-7 text-hms-gold" />
            </div>
            <p className="text-sm text-hms-text text-center font-medium">
              Allow browser notifications?
            </p>
            <p className="text-sm text-hms-textSub text-center">
              We&apos;ll notify you when guests call the front desk and
              for important booking updates — even when the app is in
              the background.
            </p>
            <div className="flex items-center gap-2 p-3 rounded-lg bg-hms-surface border border-hms-borderLt">
              <ShieldCheck className="w-4 h-4 text-hms-teal shrink-0" />
              <p className="text-xs text-hms-textDim">
                You can disable notifications anytime in Settings.
              </p>
            </div>
            <div className="flex gap-3 pt-1">
              <button
                id="calls_push_optin_deny_btn"
                type="button"
                onClick={onDeny}
                className="flex-1 px-4 py-2.5 rounded-lg text-sm font-medium border border-hms-border text-hms-textSub hover:bg-hms-surface transition-colors"
              >
                Not now
              </button>
              <button
                id="calls_push_optin_allow_btn"
                type="button"
                onClick={onAllow}
                className="flex-1 px-4 py-2.5 rounded-lg text-sm font-medium bg-hms-gold text-white hover:bg-hms-gold/90 transition-colors"
              >
                Allow
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}
